export class NotificationPrintLabelBuilder{
    constructor(obj) {
        var fullAddress  = obj.addressLine1;
        if (obj.addressLine2 !== null)
            fullAddress += " " + obj.addressLine2;

        var labelText = `<?xml version="1.0" encoding="utf-8"?>\
        <DieCutLabel Version="8.0" Units="twips">\
        <PaperOrientation>Landscape</PaperOrientation>\
        <Id>Address</Id>\
        <PaperName>30252 Address</PaperName>\
        <DrawCommands>\
            <RoundRectangle X="0" Y="0" Width="1581" Height="5040" Rx="270" Ry="270" />\
        </DrawCommands>\
        <ObjectInfo>\
            <AddressObject>\
                <Name>Address</Name>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\
                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />\
                <LinkedObjectName></LinkedObjectName>\
                <Rotation>Rotation0</Rotation>\
                <IsMirrored>False</IsMirrored>\
                <IsVariable>True</IsVariable>\
                <HorizontalAlignment>Left</HorizontalAlignment>\
                <VerticalAlignment>Middle</VerticalAlignment>\
                <TextFitMode>ShrinkToFit</TextFitMode>\
                <UseFullFontHeight>True</UseFullFontHeight>\
                <Verticalized>False</Verticalized>\
                <StyledText>\
                    <Element>\
                        <String>${obj.name}\n${fullAddress}\n${obj.city}, ${obj.stateProvince} ${obj.postalCode}</String>\
                        <Attributes>\
                            <Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />\
                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\
                        </Attributes>\
                    </Element>\
                </StyledText>\
                <ShowBarcodeFor9DigitZipOnly>False</ShowBarcodeFor9DigitZipOnly>\
                <BarcodePosition>AboveAddress</BarcodePosition>\
                <LineFonts>\
                    <Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />\
                    <Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />\
                    <Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />\
                </LineFonts>\
            </AddressObject>\
            <Bounds X="332" Y="150" Width="4455" Height="1260" />\
        </ObjectInfo>\
    </DieCutLabel>`;
        
        var label = dymo.label.framework.openLabelXml(labelText);
        
        if (label === null || label === undefined) {
            return {
                Error: true,
                ErrorMessage: "Label could not be created."
            }
        }
        
        const printers = dymo.label.framework.getPrinters();
        if (!printers || printers.length === 0) {
            return {
                Error: true,
                ErrorMessage: "No printers found."
            }
        }

        const printer = printers.find(p => p.name.startsWith("DYMO"));
        if (!printer) {
            return {
                Error: true,
                ErrorMessage: "No DYMO printer found."
            }
        }

        label.print(printer.name);
        return {
            Error: false
        }
    }
}